import { useMemo } from "react";

import { Grid } from "@material-ui/core";

import { BubbleChart } from "../../../components/charts/BubbleChart/BubbleChart";
import { Bubble } from "../../../components/charts/BubbleChart/Bubble";
import OfficeImg from "../../../assets/images/icons/workspace/office-selected.svg";
import RetailImg from "../../../assets/images/icons/workspace/retail-selected.svg";
import DataCenterImg from "../../../assets/images/icons/workspace/dataCenter-selected.svg";
import ResidentalImg from "../../../assets/images/icons/workspace/residental-selected.svg";
import HospitalityImg from "../../../assets/images/icons/workspace/hospitality-selected.svg";
import LogisticImg from "../../../assets/images/icons/workspace/logistic-selected.svg";
import { COLORS } from "../../../theme/colors";

export const SEGMENT_COLORS = {
  office: COLORS.shadowBlue,
  residential: COLORS.olivine,
  logistic: COLORS.majorelleBlue,
  retail: COLORS.blue,
  hospitality: COLORS.verdigris,
  data_centers: COLORS.pearlyPurple,
};

const SEGMENT_ICONS = {
  office: OfficeImg,
  residential: ResidentalImg,
  logistic: LogisticImg,
  retail: RetailImg,
  hospitality: HospitalityImg,
  data_centers: DataCenterImg,
};

const SIZES = {
  50: { width: 160, type: "L", numberSize: 40 },
  25: { width: 100, type: "M", numberSize: 30 },
  10: { width: 60, type: "S", numberSize: 18 },
  0: { width: 40, type: "XS", numberSize: 16 },
};

const MIN_SPACE = 5;

const getSizeOfBubble = (bubble) => {
  let size = 60;

  for (const percent in SIZES) {
    if (bubble.percent >= percent) {
      size = SIZES[percent];
    }
  }

  return size;
};

export const QuantityChart = ({
  data,
  bubbleKey = "segment",
  bubbleColors = SEGMENT_COLORS,
  icons = SEGMENT_ICONS,
}) => {
  let [largeBubble, otherBubble, restOfBubbles] = useMemo(() => {
    let largeBubble, otherBubble;
    const restOfBubbles = [];

    data.sort((a, b) => b.percent - a.percent);
    data.forEach((d) => {
      const bubble = { ...d, size: getSizeOfBubble(d) };

      if (bubble.size.type === "L") {
        largeBubble = bubble;
      } else if (bubble[bubbleKey].toLowerCase() === "others") {
        otherBubble = { ...bubble, bottom: MIN_SPACE };
      } else {
        restOfBubbles.push(bubble);
      }
    });

    return [largeBubble, otherBubble, restOfBubbles];
  }, [data]);

  return (
    <Grid container wrap="nowrap" justifyContent="center">
      {largeBubble && (
        <Grid
          item
          style={{
            width: largeBubble.size.width,
            height: largeBubble.size.width + MIN_SPACE,
            position: "relative",
          }}
        >
          <Bubble
            bubble={largeBubble}
            bubbleKey={bubbleKey}
            bubbleColors={bubbleColors}
            icons={icons}
          />
        </Grid>
      )}
      <Grid item alignItems="center">
        <BubbleChart
          bubbles={restOfBubbles}
          bubbleKey={bubbleKey}
          bubbleColors={bubbleColors}
          icons={icons}
          spacing={MIN_SPACE}
        />
      </Grid>
      {otherBubble && (
        <Grid item style={{ width: otherBubble.size.width, height: "auto", position: "relative" }}>
          <Bubble
            bubble={otherBubble}
            bubbleKey={bubbleKey}
            bubbleColors={bubbleColors}
            icons={icons}
          />
        </Grid>
      )}
    </Grid>
  );
};
